import { FC } from 'react';

import { IconButton, SvgIcon } from '@mui/material';

import { ReactComponent as CloseIcon } from 'assets/icons/CloseIcon.svg';

import { DrawerStyled } from './styled';
import { IBottomSliderProps } from './types';

export const BottomSlider: FC<IBottomSliderProps> = ({ children, isOpened, onClose }) => {
  return (
    <DrawerStyled anchor="bottom" open={isOpened} onClose={onClose}>
      <IconButton className="close_icon_button" onClick={onClose}>
        <SvgIcon component={CloseIcon} />
      </IconButton>
      {children}
    </DrawerStyled>
  );
};
